import { LoginForm } from "../components/form/LoginForm";
import Logo from "../assets/img/logos/divixBlanco.png";

import { useTranslation } from "react-i18next";
import { LegalModal } from "../components/modals/LegalModal";
import { useLayoutEffect, useMemo } from "react";
import { useAuth } from "../context/auth-context";
import { useNavigate, Link } from "react-router-dom";
import { getTokenPayload } from "../utils/token";
import { getCountryCodeFromDomain, COUNTRIES } from "../constants/countries";

export function Login() {
  const { t } = useTranslation();
  const { isAuthenticated, token } = useAuth();
  const navigate = useNavigate();

  // Detectar si es Argentina usando el enum de países
  const isArgentina = useMemo(() => {
    return getCountryCodeFromDomain() === COUNTRIES.AR;
  }, []);

  useLayoutEffect(() => {
    if (isAuthenticated && token) {
      const isFirstLogin = getTokenPayload(token).isFirstLogin;
      if (isFirstLogin) {
        navigate("/setup-branch");
      } else {
        navigate("/dashboard");
      }
    }
  }, [isAuthenticated, navigate, token]);

  return (
    <div className="container h-screen relative grid flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0">
      <LegalModal />
      {/* Logo section */}
      <div className="relative hidden h-full flex-col p-10 text-white lg:flex lg:justify-center lg:items-center bg-dark-gradient-to-b">
        <img className="w-32 mx-auto" src={Logo} alt="Divix Logo" />
        <h1 className="mt-6 text-3xl font-light tracking-wide">
          {t("login.welcome")}
        </h1>
        <p className="mt-2 text-lg font-semibold tracking-widest">{t("login.role")}</p>
      </div>

      {/* Login section */}
      <div className="lg:p-4">
        <div className="mx-auto text-white flex w-full border rounded-xl flex-col justify-center space-y-4 py-4 sm:w-[400px] bg-dark-gradient-to-b">
          <div className="flex space-y-2 mx-auto">
            <svg
              width="101"
              height="101"
              viewBox="-1.68 -1.68 27.36 27.36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              stroke="#EF0BB8"
            >
              <g
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke="#EF0BB8"
                strokeWidth=".312"
              >
                <circle opacity=".5" cx="12" cy="9" r="3" />
                <circle cx="12" cy="12" r="10" />
                <path
                  opacity=".5"
                  d="M17.97 20c-.16-2.892-1.045-5-5.97-5s-5.81 2.108-5.97 5"
                />
              </g>
              <g strokeWidth=".312">
                <circle opacity=".5" cx="12" cy="9" r="3" />
                <circle cx="12" cy="12" r="10" />
                <path
                  opacity=".5"
                  d="M17.97 20c-.16-2.892-1.045-5-5.97-5s-5.81 2.108-5.97 5"
                  strokeLinecap="round"
                />
              </g>
            </svg>
          </div>

          <div className="grid py-4 gap-6">
            <LoginForm />
          </div>
        </div>
        <div className="mx-auto mt-4 sm:w-[400px] text-center">
          {isArgentina ? (
            <a
              href="https://www.divix.net/#contacto"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:underline font-bold"
            >
              {t("login.register")}
            </a>
          ) : (
            <Link
              to="/register"
              className="text-black hover:underline font-bold"
            >
              {t("login.register")}
            </Link>
          )}
        </div>
          {isArgentina && (
            <div className="mx-auto mt-4 sm:w-[500px] px-6 text-center">
              <div className="text-black text-sm">
                <span className="font-medium leading-relaxed font-light font-Montserrat text-black">
                  Si descargaste la app en <span className="font-medium" style={{color: '#228704'}}>CLOVER</span>, finalizá el proceso desde tu terminal de cobro yendo a Mis Aplicaciones y abriendo Divix.
                </span>
              </div>
            </div>
          )}
      </div>
    </div>
  );
}
